<template>
  <div
    @mouseover="hover = true"
    @mouseleave="hover = false"
    class="content-row relative border border-solid border-transparent rounded-lg"
    :class="[{ 'border-gray-300 border-dotted blue-hover': hover }]"
    :style="{ margin: margin, 'min-height': '20px'  }"
  >
    <div
      ref="menu"
      class="tippy-holder flex flex-row justify-center items-center"
    >
      <div
        class="bubble-menu bg-white rounded-lg p-1 mb-1 shadow-lg flex flex-row justify-center"
      >
        <button
          class="menu flex flex-col items-center justify-center"
          style="padding:0px;"
          v-tooltip="'Delete Row'"
        >
          <div @click="deleteRow(row)">
            <svg-icon
              icon="heroicons/outline/trash"
              class="w-6 h-6 cursor-pointer"
            />
          </div>
        </button>

        <!--

        <button
          class="menu flex flex-col items-center justify-center"
          style="padding:0px;"
          v-tooltip="'Copy'"
        >
          <span class="material-icons" @click="copyContainer">
            content_copy
          </span>
        </button>

        -->

        <BasePopover :showPopover="showMarginPopover" transition="grow">
          <template v-slot:button>
            <button
              class="menu flex flex-col items-center justify-center relative"
              @click="showMarginPopover = true"
              :style="{ padding: '8px' }"
              v-tooltip="'Row width'"
            >
              <span class="material-icons">
                crop_7_5
              </span>
            </button>
          </template>

          <template v-slot:body>
            <div
              id="button-settings"
              class="bg-white border border-solid border-gray-300 shadow-lg rounded mt-2 z-10 inline-block text-left pl-3 pb-1"
              style="right: 0%;"
            >
              <div class="flex flex-row-reverse">
                <div @click="showMarginPopover = false">
                  <svg-icon
                    icon="heroicons/outline/x"
                    class="w-3 h-3 text-gray-400 hover:text-gray-300 font-bold mt-2 mr-2 cursor-pointer"
                  />
                </div>
              </div>

              <div
                class="pr-3 flex mb-0 list-none flex-wrap pt-0 pb-1 flex-row"
              >
                <table>
                  <tbody>
                    <tr>
                      <td class="pr-3 py-1 text-xs">Row Width</td>
                      <td class="pr-5 py-1">
                        <input
                          :value="maxWidth"
                          @change="maxWidth = $event.target.value"
                          class="text-center w-12 h-8 rounded border border-solid border-gray-300"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
        </BasePopover>
      </div>
    </div>

    <div
      v-show="hover"
      class="row-handle z-5"
      ref="trigger"
      @mouseover="myhandle_hover = true"
      @mouseleave="myhandle_hover = false"
      v-tooltip="{
        trigger: 'manual',
        show: myhandle_hover && !bubbleMenu.state.isVisible,
        content: '<b>Drag</b> to move row<br /><b>Click</b> to open menu',
      }"
    >
      <span class="material-icons text-gray-400 hover:text-blue-500">
        drag_indicator
      </span>
    </div>

    <div :style="{ 'max-width': maxWidth + 'px' }" class="m-auto relative">
      <draggable
        v-model="columns"
        :group="{ name: 'column', pull: false, put: false }"
        draggable=".drag-section"
        handle=".column-handle"
        @start="onDragStart"
        @end="onDragEnd"
        :key="row.id"
        :style="{
          display: 'grid',
          'grid-template-columns': `repeat(${columns.length}, minmax(0, 1fr))`,
          gap: '4px',
        }"
      >
        <div v-for="column in columns" :key="column.id" class="drag-section">
          <option-column
            v-if="column.type == 'OPTION'"
            @close-menu="closeBubble"
            @delete-row="deleteRow"
            :column_id="column.id"
            :length="columns.length"
            :survey="survey"
            :step="step"
            :row="row"
          >
          </option-column>

          <content-column
            v-else
            @close-menu="closeBubble"
            @delete-row="deleteRow"
            :column_id="column.id"
            :length="columns.length"
            :survey="survey"
            :step="step"
            :row="row"
          >
          </content-column>
        </div>
      </draggable>
    </div>

    <div v-if="hover" @click="addColumn">
      <svg-icon
        icon="heroicons/outline/plus-circle"
        class="plus-icon right mx-auto my-auto cursor-pointer text-gray-400 hover:text-blue-500"
        v-tooltip="'Add new section'"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import Row from "@/models/content/Row";
import Column from "@/models/content/Column";
import Content from "@/models/content/Content";
//import TEXTContent from "@/components/Content/TextContent";
//import IMAGEContent from "@/components/Content/ImageContent";
//import BUTTONContent from "@/components/Content/ButtonContent";
//import TEXTOPTIONContent from "@/components/Content/TextOptionContent";
//import COLUMNContent from "@/components/Content/ContentColumn";
import tippy from "tippy.js";
import Draggable from "vuedraggable";
import ContentColumn from "@/components/Content/ContentColumn.vue";
import OptionColumn from "@/components/Content/OptionColumn.vue";

export default {
  name: "content-row",
  components: {
    //TEXTContent,
    //IMAGEContent,
    //BUTTONContent,
    //TEXTOPTIONContent,
    Draggable,
    ContentColumn,
    OptionColumn,
  },
  data() {
    return {
      hover: false,
      loaded: false,
      showMarginPopover: false,
      bubbleMenu: null,
      myhandle_hover: false,
      horizontalDragActive: false,
    };
  },
  props: ["row_id", "survey", "step", "dragActive", "modalWidth"],
  computed: {
    row() {
      return Row.query()
        .whereId(this.row_id)
        .with("columns", (query) => {
          query.orderBy("order", "asc");
        })
        .first();
    },
    columns: {
      get() {
        return this.row.columns;
      },
      set(cols) {
        let reorderedList = Column.reIndexList(cols);

        Column.update({
          data: reorderedList,
        });
      },
    },
    gridColumns() {
      let n = this.columns.length;
      return `grid-cols-${n}`;
    },
    width: {
      get() {
        return this.row.width || "auto";
      },
      set(value) {
        Row.update({
          where: this.row.id,
          data: { width: value },
        });
      },
    },
    height: {
      get() {
        return this.row.height || "auto";
      },
      set(value) {
        Row.update({
          where: this.row.id,
          data: { height: value },
        });
      },
    },
    top: {
      get() {
        return this.row.top;
      },
      set(value) {
        Row.update({
          where: this.row.id,
          data: { top: value },
        });
      },
    },
    left: {
      get() {
        return this.row.left;
      },
      set(value) {
        Row.update({
          where: this.row.id,
          data: { left: value },
        });
      },
    },
    marginTop: {
      get() {
        return this.row.marginTop;
      },
      set(value) {
        Row.update({
          where: this.row.id,
          data: { marginTop: value },
        });
      },
    },
    marginBottom: {
      get() {
        return this.row.marginBottom;
      },
      set(value) {
        Row.update({
          where: this.row.id,
          data: { marginBottom: value },
        });
      },
    },
    margin() {
      return `${this.marginTop}px 0 ${this.marginBottom}px 0`;
    },

    maxWidth: {
      get() {
        let modalWidth = this.modalWidth;
        if (modalWidth == null || modalWidth == undefined) return this.row.maxWidth;
        return Math.min(this.row.maxWidth, this.modalWidth);

      },
      set(value) {
        console.log("setting value: " + value);
        if (isNaN(value)) value = null;
        //if (this.step.type == "MODAL" && value > 800) value = 800; //dont allow max width greater than 600 in modal view
        Row.update({
          where: this.row.id,
          data: { maxWidth: value },
        });
      },
    },
  },
  methods: {
    onDragStart: function(evt) {
      this.$store.commit("SET_DRAG_STATE", true);
      //this.dragActive = true;
    },
    onDragEnd: function(evt) {
      this.$store.commit("SET_DRAG_STATE", false);
      //this.dragActive = false;
    },
    resize(newRect) {
      this.width = newRect.width;
      this.height = newRect.height;
      this.top = newRect.top;
      this.left = newRect.left;
    },
    closeBubble() {
      //Close BubbleMenus generated by TipTap editor (uses Tippy.js under the hood)
      const editors = document.querySelectorAll(".ProseMirror");
      editors.forEach((editor) => {
        const tippy = editor._tippy;
        tippy?.hide();
      });
    },
    /*
    setAlign(dir) {
      this.align = dir;
    },
    */
    async copyContainer() {
      let container = this.row;
      let copyData = container.$clone();

      var newContainer = await Row.insertNew({
        data: copyData,
      });
    },
    /*
    async addContentColumn(type) {
      let column_id = Column.uuidv4();

      //create the container column and insert the content
      await Column.insert({
        data: {
          id: column_id,
          row_id: this.row.id,
              contents: [{ type: type, column_id: column_id }],
          }
      });

      //this.showContentMenu = false;
    },
    */
    async deleteRow(row) {
      var result = await Row.api().delete("/api/row/delete/" + row.id);

      if (result.response.status == 200) {
        //Delete step from entities state
        row.columns.forEach((column) => {
          column.contents.forEach((content) => {
            Content.delete(content.id);
          });
          Column.delete(column.id);
        });
        row.$delete();
      } else {
        //Delete failed
        this.$store.dispatch("notification/add", {
          message: "An error occured deleting option",
        });
      }
    },
    async addColumn() {
      let column_id = Column.uuidv4();

      //create new container column on the same row
      await Column.insert({
        data: {
          id: column_id,
          row_id: this.row.id,
          contents: [],
        },
      });
    },
    /*
    async addContent(type) {
      console.log("hello");
      await Content.insertNew({
        data: { type: type, row_id: this.row.id },
      });
    },
    async deleteContent(content) {
      await Content.delete(content.id);
    },
    */
  },
  mounted() {
    this.loaded = true;

    let trigger = this.$refs.trigger;
    let menu = this.$refs.menu;

    this.bubbleMenu = tippy(trigger, {
      content: menu,
      interactive: true,
      duration: 100,
      maxWidth: "none",
      hideOnClick: true,
      trigger: "click",
      onClickOutside(instance, event) {
        instance.hide();
        //console.log(instance);
      },
    });
  },
};
</script>

<style lang="scss">
@import "@/assets/editor.scss";

.blue-hover {
  background: rgba(164, 217, 248, 0.15);
}

/* Menu styles */

.bubble-menu {
  border: 1px solid #e1e1e1;

  .outer-button {
    border: 1px solid gray;
    border-radius: 100%;
    padding: 8px;
  }

  button.menu {
    background: none;
    margin: 5px;
    outline: none;
    -webkit-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
    min-width: 35px;
    height: 35px;

    border-radius: 5px;
    text-align: center;
    padding: 5px;
    display: inline-flex;
    align-items: center;
    color: #555555;

    &:focus {
      outline: none;
      box-shadow: 0 0 2pt 1pt #7424cc;
    }
    &:hover,
    &.is-active {
      opacity: 1;
      background-color: rgb(218, 218, 252);
      color: #7424cc;
    }
  }

  //Verte Color Picker
  button.verte__guide {
    padding: 0;
    min-width: 20px;
    width: 45px;

    &:focus {
      outline: none;
    }
  }
  button.verte__close {
    min-width: 1px;
  }
  .verte__menu {
    border-radius: none !important;
  }
  .verte__controller {
    padding: 0 20px 5px;
  }
  .verte__inputs {
    font-size: 13px;
  }
  .verte__input {
    padding: 1px;
  }
  .verte-picker {
    margin: 0 auto;
  }
  .verte-picker__slider {
    margin: 5px 20px 5px;
  }

  .font__setter {
    margin: 5px;
  }

  .font__setter > div,
  .font__setter > input {
    &:hover,
    &.is-active {
      opacity: 1;
      background-color: rgb(218, 218, 252);
      color: #7424cc;
    }
  }
}
</style>
